/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PaginationComponent from "react-reactstrap-pagination";




// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "../IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}-${new Date().getTime()}`,
    content: `item ${k + offset}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF"),
  display:'flex',
  width:'100%',
  // styles we need to apply on draggables
  ...draggableStyle
});
const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  borderBottom: '6px solid #091E3F',
  minHeight:'80px',
  // marginBottom:'20px'
});

function Index(props) {
  const [selectedPage, setSelectedPage] = useState(0);
  var pageSize = 20;

  useEffect(() => {
   
  },[]);
  const setposition = (index, value)=>{
    
  }
  console.log( props.tableData)
  var dataSet = props.tableData
  var tableData = dataSet
  return (
    <div>
      <Table  striped >
        <thead>
          <tr>
            <th>#</th>
            <th>Size</th>
            <th>Order</th>
          </tr>
        </thead>
        <tbody>
          {
            tableData.map((row, index)=>{                          
              return (
                <tr>
                  <th scope="row">{row['index']*1+1}</th>
                  <td>{row['sizename']}</td>
                  <td><Input value={row['position']} onChange={(e)=>props.setposition(index,e.target.value)} onBlur={(e)=>props.updateposition(index,e.target.value)}/></td>
                  {/* <td><Input placeholder="Email" value={row['position']} onChange={(e)=>setEmailaddress(e.target.value)}/></td> */}
                </tr>
              )
            })
          }
        </tbody>
      </Table>
    </div>            
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
